import { supabase } from "../supabase/client";

/**
 * Enhanced auth state debugger with comprehensive logging
 */
export const debugAuthState = async (message?: string, data?: any) => {
  console.group("🔍 Auth State Debugging");
  
  if (message) {
    console.log(`📌 ${message}`, data);
  }
  
  try {
    // Get Supabase session directly to avoid circular dependency
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    console.log('📊 Current State:', {
      timestamp: new Date().toISOString(),
      supabase: {
        sessionId: session?.user?.id,
        sessionError,
        expiresAt: session?.expires_at ? new Date(session.expires_at * 1000).toISOString() : null
      }
    });
    
    // Check localStorage
    console.log('🗄️ Storage State:');
    const supabaseKeys = Object.keys(localStorage).filter(key => key.includes('supabase'));
    supabaseKeys.forEach(key => {
      try {
        const value = localStorage.getItem(key);
        console.log(`  ${key}:`, value ? JSON.parse(value) : null);
      } catch (e) {
        console.log(`  ${key}: [parse error]`);
      }
    });
    
    // Test localStorage
    try {
      const testKey = "auth-debug-test";
      localStorage.setItem(testKey, "test");
      const testValue = localStorage.getItem(testKey);
      localStorage.removeItem(testKey);
      console.log(`localStorage working: ${testValue === "test" ? "✅ Yes" : "❌ No"}`);
    } catch (e) {
      console.log("❌ localStorage not available:", e);
    }
    
  } catch (error) {
    console.error("Debug error:", error);
  }
  
  console.groupEnd();
  return "Debug complete - check console";
};

// Auth flow tracer for debugging state transitions
export function traceAuthFlow(step: string, data?: any) {
  const trace = {
    step,
    timestamp: new Date().toISOString(),
    data,
    stack: new Error().stack?.split('\n').slice(2, 5).join('\n')
  };
  
  console.log(`🔄 Auth Flow: ${step}`, trace);
  
  // Store in session storage for debugging
  const traces = JSON.parse(sessionStorage.getItem('auth_traces') || '[]');
  traces.push(trace);
  if (traces.length > 50) traces.shift(); // Keep last 50 traces
  sessionStorage.setItem('auth_traces', JSON.stringify(traces));
}

export function getAuthTraces() {
  return JSON.parse(sessionStorage.getItem('auth_traces') || '[]');
}

// Helper to clear all auth-related data for debugging
export function clearAuthData() {
  console.log('🧹 Clearing all auth data...');
  
  // Clear localStorage
  const keysToRemove = Object.keys(localStorage).filter(key => 
    key.includes('supabase') || key.includes('auth')
  );
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Clear sessionStorage
  sessionStorage.removeItem('auth_traces');
  
  console.log('✅ Auth data cleared');
}
